export default "__VITE_ASSET__5ee21ca2__"